import React, { useState, useEffect } from 'react';
import api from '../services/api';

export default function Attendance() {
  const [data, setData]   = useState(null);
  const [from, setFrom]   = useState(new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().split('T')[0]);
  const [to, setTo]       = useState(new Date().toISOString().split('T')[0]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get(`/attendance?from=${from}&to=${to}`)
      .then(r => setData(r.data.data))
      .finally(() => setLoading(false));
  }, [from, to]);

  const statusConfig = { present: 'success', absent: 'danger', leave: 'warning' };

  return (
    <>
      <div className="d-flex align-items-center justify-content-between mb-4 flex-wrap gap-2">
        <h5 className="fw-bold mb-0">My Attendance</h5>
        <div className="d-flex gap-2 align-items-center">
          <input type="date" className="form-control form-control-sm" value={from} onChange={e => setFrom(e.target.value)} />
          <span className="text-muted small">to</span>
          <input type="date" className="form-control form-control-sm" value={to} onChange={e => setTo(e.target.value)} />
        </div>
      </div>

      {/* Summary cards */}
      {data && (
        <div className="row g-3 mb-4">
          {[
            { label: 'Total Days', value: data.total, icon: 'bi-calendar3', color: 'primary' },
            { label: 'Present',    value: data.present, icon: 'bi-check-circle-fill', color: 'success' },
            { label: 'Absent',     value: data.total - data.present - (data.records?.filter(r=>r.status==='leave').length||0), icon: 'bi-x-circle-fill', color: 'danger' },
            { label: 'Percentage', value: `${data.percentage}%`, icon: 'bi-percent', color: 'info' },
          ].map(c => (
            <div className="col-6 col-md-3" key={c.label}>
              <div className="stat-card text-center">
                <i className={`bi ${c.icon} text-${c.color} fs-3 mb-2`} />
                <div className="fs-4 fw-bold">{c.value}</div>
                <div className="text-muted small">{c.label}</div>
              </div>
            </div>
          ))}
        </div>
      )}

      {loading ? (
        <div className="text-center py-4"><div className="spinner-border text-primary" /></div>
      ) : (
        <div className="table-card">
          <table className="table table-hover align-middle mb-0">
            <thead>
              <tr>
                <th>Date</th>
                <th>Day</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {data?.records?.length === 0 ? (
                <tr><td colSpan={3} className="text-center text-muted py-4">No attendance records found</td></tr>
              ) : data?.records?.map(r => (
                <tr key={r.id}>
                  <td>{new Date(r.attendance_date).toLocaleDateString('en-IN', {day:'2-digit',month:'short',year:'numeric'})}</td>
                  <td className="text-muted small">{new Date(r.attendance_date).toLocaleDateString('en-IN',{weekday:'long'})}</td>
                  <td><span className={`badge bg-${statusConfig[r.status]}`}>{r.status.charAt(0).toUpperCase()+r.status.slice(1)}</span></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </>
  );
}
